import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { BaseCompanyIdProps } from "@custom-types/base-types";
import { BaseMemberProps } from "@custom-types/member-types";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useMembersUtils } from "@hooks/use-member-utils";
import { Stack } from "@mui/material";
import { useAppSelector } from "@store/store-helper";
import { getCompanyByIdSelector } from "@store/sdb-company/sdb-company-selector";
import { SHOW_ON_HOVER_CLASS } from "@utils/ui-utils";
import { RemoveSingleMemberFromEntity } from "@components/remove-single-member-from-entity";
import { Button } from "@flat-ui";

/** Actions available for each active member in the active members table */
export function ActiveMemberActions({
  companyId,
  member,
}: BaseMemberProps & BaseCompanyIdProps): JSX.Element {
  const { openProfilePage } = useMembersUtils();
  const { canDeleteMemberFromCompany } = useHasUserValidRoleCompanyLevel();
  const selectedSdbCompany = useAppSelector(getCompanyByIdSelector(companyId));

  return (
    <Stack
      className={SHOW_ON_HOVER_CLASS}
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "flex-end",
        visibility: "hidden",
        width: "100%",
      }}
    >
      <Button
        variant="ghost"
        size="s"
        sx={{ textTransform: "inherit" }}
        onClick={() =>
          openProfilePage({
            userIdentity: member.identity,
            source: "active members table",
          })
        }
      >
        View profile
      </Button>

      {canDeleteMemberFromCompany && selectedSdbCompany && (
        <>
          <SphereActionDivider />
          <RemoveSingleMemberFromEntity
            companyId={companyId}
            member={member}
            entity={selectedSdbCompany}
            entityName="activeMembers"
          />
        </>
      )}
    </Stack>
  );
}
